import API from 'api.js';

class NetworkManager {
  constructor() {
    this.failedRequests = [];
    this.isRetrying = false;
  }

  async submitWithRetry(requestData, maxRetries = 3) {
    //If we remove this if condition then the request will be in the Pending state for 10mins and after that it will success
     if (requestData.url === 'submit/mock') {
      requestData.timeout = 180000; // 3 minutes
    }
    for (let i = 0; i < maxRetries; i++) {
      try {
        const response = await API(requestData);
        return response;
      } catch (error) {
        if (i === maxRetries - 1) {
          this.failedRequests.push(requestData);
          throw error;
        }
        await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
      }
    }
  }

  async retryFailedRequests() {
    if (this.isRetrying || this.failedRequests.length === 0) return;
    
    this.isRetrying = true;
    const requests = [...this.failedRequests];
    this.failedRequests = [];

    for (const request of requests) {
      try {
        await API(request);
      } catch (error) {
        this.failedRequests.push(request);
      }
    }
    this.isRetrying = false;
  }

   getFailedRequests() {
    return this.failedRequests;
  }

  clearFailedRequests() {
    this.failedRequests = [];
  }

  getFailedRequestsCount() {
    return this.failedRequests.length;
  }
}

export default new NetworkManager();
